module.exports = __webpack_public_path__ + "static/media/landing.334e2016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing.jpg
// module id = 448
// module chunks = 0